import { mergeMap, map, filter, take, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isAuthenticatedSelector } from '@cbridge-packages/auth';
import { queryParamSelector } from '@cbridge-packages/routing';
import { PageContextAction } from '@cbridge-packages/page-context';
import { SymbolPoolAction } from '../symbolPool.action';
import { NodeParam } from '../_helpers/nodeSearchParam';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>
  & IGetSelectorStateType<typeof isAuthenticatedSelector>;

export const initSymbolPoolEpic: IEpic<IState> = (action$, state$) => {
  return state$.pipe(
    map(state => ({
      nodeId: queryParamSelector(state, NodeParam.name),
      isAuthenticated: isAuthenticatedSelector(state),
    })),
    filter(({ nodeId, isAuthenticated }) => nodeId && isAuthenticated),
    distinctUntilChanged(),
    take(1),
    mergeMap(({ nodeId }) => {
      const parsedNodeId = Number(nodeId);
      if (Number.isNaN(parsedNodeId)) {
        return [];
      }

      return [
        SymbolPoolAction.select({ nodeId: parsedNodeId }),
      ];
    }),
    takeUntil(
      action$.pipe(
        isTypeOf(PageContextAction.init.done, PageContextAction.init.failed),
      ),
    ),
  );
};
